module.exports = __webpack_public_path__ + "img/album22_06.55d866ef.jpg";